import { render, staticRenderFns } from "./NotificationActionForm.vue?vue&type=template&id=08a6613a&scoped=true&"
import script from "./NotificationActionForm.vue?vue&type=script&lang=js&"
export * from "./NotificationActionForm.vue?vue&type=script&lang=js&"
import style0 from "./NotificationActionForm.vue?vue&type=style&index=0&id=08a6613a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a6613a",
  null
  
)

/* custom blocks */
import block0 from "./NotificationActionForm.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports